export default __webpack_public_path__ + "static/media/co9.4f1be6ac.png";